import { useMemo } from "react";
import { buildOfficialResult } from "../logic/result";
import { OfficialResultHeroScreen } from "./OfficialResultHeroScreen";
import { OfficialResultCardScreen } from "./OfficialResultCardScreen";
import { OfficialResultSongsScreen } from "./OfficialResultSongsScreen";
import type { Song } from "../types";

export function ResultScreen({ route, songs, onRestart, onNavigate }: {
  route: "result" | "result-songs" | "result-card";
  songs: Song[];
  onRestart(): void;
  onNavigate(path: string): void;
}) {
  const result = useMemo(() => buildOfficialResult(songs), [songs]);
  if (route === "result-card") {
    return <OfficialResultCardScreen result={result} onBack={() => onNavigate("/result")} onCreateMatch={() => onNavigate("/match/invite")} />;
  }
  if (route === "result-songs") {
    return <OfficialResultSongsScreen result={result} onBack={() => onNavigate("/result")} onCreateCard={() => onNavigate("/result/card")} />;
  }
  return <OfficialResultHeroScreen result={result} onViewSongs={() => onNavigate("/result/songs")} onCreateCard={() => onNavigate("/result/card")} onRestart={onRestart} />;
}
